<template>
    <div id="availability">
        <div class="material-icons time-icon">event_available</div>
        <div class="content">
            <div class="header" @click="changeVisible">
                <div class="header-titles">
                    <span class="header-title">{{ $t("calendar.receivedAppointInterval")}}</span>
                    <span class="header-sub-title">{{ $t("calendar.receivedAppointIntervalDesc")}}</span>
                </div>
                <div class="material-icons" v-if="visible">expand_less</div>
                <div class="material-icons" v-else>expand_more</div>
            </div>
            <div v-if="visible">
                <div class="section">
                    <div class="label">{{ $t("calendar.interimTime") }}</div>
                    <div class="sub-label">{{ $t("calendar.interimTimeDesc") }}</div>
                    <div style="margin-top: 5px">
                        <input class="input-checkbox" type="checkbox" v-model="setting.isBufferTimeMinute" />
                        <input
                            class="input-number"
                            type="number"
                            v-model="setting.bufferTimeMinute"
                            :disabled="!setting.isBufferTimeMinute"
                            min="1"
                        />
                        <span>{{ $t("report.minute") }}</span>
                    </div>
                </div>
                <div class="section bottom">
                    <div class="label">{{ $t("calendar.dayMaxRes")}}</div>
                    <div class="sub-label">
                        {{ $t("calendar.dayMaxResDesc")}}
                    </div>
                    <div style="margin-top: 5px">
                        <input class="input-checkbox" type="checkbox" v-model="setting.isMaxBookingCountPerDay" />
                        <input
                            class="input-number"
                            type="number"
                            v-model="setting.maxBookingCountPerDay"
                            :disabled="!setting.isMaxBookingCountPerDay"
                            min="1"
                        />
                        <span>{{ $t("report.hour") }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../../../utils/log2";
import _ from "lodash";

const log = log2("Setting");
export default {
    name: "Setting",
    components: {},
    props: {
        value: {
            type: Object,
        },
    },
    data() {
        return {
            setting: _.clone(this.value),
            visible: false,
        };
    },
    computed: {
        ...mapState({}),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({}),
        ...mapMutations({}),
        changeVisible() {
            this.visible = !this.visible;
        },
    },
    async mounted() {},
    beforeDestroy() {},
    watch: {
        setting: {
            handler(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
#availability {
    .ant-select-selection {
        border: none !important;
        border-radius: 0 !important;
        margin-top: 6px;
        background-color: white !important;
    }

    .ant-select-selection__rendered {
        margin-left: 0 !important;
    }
}
</style>

<style lang="scss" scoped>
#availability {
    display: flex;
    flex-direction: row;
    margin-top: 20px;

    .time-icon {
        margin-top: 7px;
        margin-right: 20px;
        font-size: 20px;
    }

    .content {
        display: flex;
        flex-direction: column;
        width: 100%;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            cursor: pointer;
            border-radius: 5px;
            padding: 5px;

            &:hover {
                background-color: #e3e3e3;
            }

            .header-titles {
                display: flex;
                flex-direction: column;

                .header-title {
                    color: black;
                    font-weight: 500;
                    font-size: 16px;
                }

                .header-sub-title {
                    font-size: 12px;
                }
            }
        }

        .section {
            display: flex;
            flex-direction: column;
            margin-top: 10px;

            &.bottom {
                margin-top: 20px;
            }

            .input-checkbox {
                margin-right: 10px;
            }

            .label {
                font-size: 12px;
                font-weight: 700;
            }

            .input-number {
                margin-right: 10px;
                border: none;
                background-color: #e3e3e3;
                border-radius: 5px;
                height: 35px;
                width: 60px;
                padding: 10px;
            }
        }
    }
}
</style>
